<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :details="details"/>
        <Items :access="access" :items="details.Items"/>

        <template v-if="access.Glob_HPP">
          <Total :details="details"/>
        </template>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../StopInfo.js";
import Model from "../StopModel.js";
import Services from "../../../services/Api/StockOpnameServices.js";

import Details from "./StopD_Details.vue";
import Items from "./StopD_Items.vue";
import Total from "./StopD_Total.vue";

export default {
  components: {
    Details,
    Items,
    Total
  },
  data: () => ({
    access: {},
    actions: [],
    details: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    }
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.details = data.Details;
      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData(id) {
      this.access = this.$kst.Access.create(Model.Access);
      this.actions = Model.Details.getActions(id, this.access);
      this.details = {};
    }
  }
}
</script>